<template>
  <div>
    <a-table :columns="columns" :data-source="data"
             size="small"
             :loading="loading"
             rowKey="id"
             :pagination="false"
             :scroll="{y:'200px'}"
    >
      <span slot="action" slot-scope="text,record,index">
              <a @click="handleEdit(record)">修改</a>
              <a-divider type="vertical"/>
        <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
              <a>删除</a>
            </a-popconfirm>
      </span>
    </a-table>
    <a-button  type="primary" style="margin-top: 10px" v-if="edit" @click="handleAdd">添加分组</a-button>
    <a-button  style="margin-top: 10px;margin-left: 10px" v-if="edit" @click="edit=false">完成编辑</a-button>
    <a-button  type="primary" style="margin-top: 10px" v-if="!edit" @click="edit=true">编辑分组</a-button>
    <a-modal
      title="编辑"
      rowKey="id"
      :width="1000"
      :visible="formVisible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel">
      <a-form-model :model="formData" layout="horizontal" style="padding-left: 20px;padding-right: 20px;"
                    v-bind="{
            labelCol: { span:4 },
            wrapperCol: { span: 16 },
          }"
      >
        <a-form-model-item label="分组名称">
          <a-input v-model="formData.name" />
        </a-form-model-item>
        <a-form-model-item label="受试者数量">
          <a-input-number v-model="formData.num" :min="0" :precision="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-input v-model="formData.description" />
        </a-form-model-item>

      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import { getAction,postAction,deleteAction } from '@api/manage'
  export default {
    name: 'GroupList',
    props:{
      projectId:{
        type:String,
        default:'',
      }
    },
    data(){
      return {
        edit:false,
        data:[],
        loading:false,
        formVisible:false,
        confirmLoading:false,
        formData:{},
      }
    },
    computed:{
      columns(){
        const columns = [{
          title: '分组名称',
          align:'center',
          dataIndex: 'name',
          ellipsis: true,// 表格省略
          width: 150,
        },
          {
            title: '受试者数量',
            align:'center',
            dataIndex: 'num',
            width: 150,
          },
          {
            title: '备注',
            align:'center',
            dataIndex: 'description',
            ellipsis: true,// 表格省略
          },]
        if(this.edit){
          columns.push({
            title: '操作',
            align:'center',
            width: 100,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          })
        }
        return columns
      }
    },
    watch:{
      projectId(){
        this.loadData()
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        if(this.projectId){
          this.loading = true
          getAction('/project/projectGroup/list',{projectId:this.projectId}).then(res=>{
            if(res.success){
              this.data = res.result
            }
          }).finally(()=>{
            this.loading = false
          })
        }
      },
      handleEdit(record){
        this.formData = Object.assign({},record)
        this.formVisible = true
      },
      handleAdd(){
        this.handleEdit({
          projectId:this.projectId,
          name:'',
          num:null,
          description:'',
        })
      },
      handleDelete(record){
        deleteAction('/project/projectGroup/delete',{id:record.id}).then(res=>{
          if(res.success){
            this.loadData()
          }
        })
      },
      handleSubmit(){
        this.confirmLoading = true
        postAction('/project/projectGroup/saveOrUpdate',this.formData).then(res=>{
          if(res.success){
            this.loadData()
            this.handleCancel()
          }
        }).finally(()=>{
          this.confirmLoading = false
        })
      },
      handleCancel(){
        this.formData = {}
        this.formVisible = false
      },
    }
  }
</script>

<style scoped>

</style>